import React from 'react'

export const CardsListUnstyled = props => {
  return <div className={props.className}>{props.children}</div>
}



// WEBPACK FOOTER //
// ./src/Components/CardsList/unstyled.js